<div *ngIf="nodes.length" class="workflow-node-parameters">
  <div class="workflow-node-parameters__node-header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Properties</h2>

    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="workflow-node-parameters__event-flow-title">
    <app-mat-text-input [formControl]="eventFlowNameControl" label="Event Flow Title"> </app-mat-text-input>
  </div>

  <div *ngFor="let item of nodes">
    <div class="workflow-node-parameters__node-card">
      <div class="workflow-node-parameters__event-info">
        <div fxLayout-="row">
          <div fxLayout="column" fxFlex="90">
            <span>
              <mat-icon>{{ item.icon }}</mat-icon>
              {{ item.name }}
            </span>

            <span>
              <mat-icon>info</mat-icon>
              {{ item.description }}
            </span>
          </div>
          <div *ngIf="isNodeEventType(item.type)" fxLayout="column" fxLayoutAlign="center center" fxFlex="10">
            <button mat-icon-button class="button-40" (click)="onOpenEdit(item)">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="workflow-node-parameters__event-settings">
        <div>
          <mat-slide-toggle [(ngModel)]="item.value.enabled"></mat-slide-toggle>
          <span> {{ item.value.enabled ? 'Enabled' : 'Disabled' }}</span>
        </div>

        <div *ngIf="getEventDataExample(item.type) as eventDataExample" class="workflow-node-parameters__event-example">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> Event Data Example </mat-panel-title>
              </mat-expansion-panel-header>
              <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 20px">
                <span>Content type</span>
                <span>application/json</span>
              </div>
              <div class="workflow-node-parameters__event-data-example">
                <ngx-json-viewer [expanded]="true" [json]="eventDataExample"></ngx-json-viewer>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <div [ngSwitch]="item.value.actionType">
          <events-flow-url-settings
            *ngSwitchCase="EventsFlowActionNodeTypes.SendToUrl"
            [actionItemFormGroup]="getActionItemSettingsForm(item?.value?.uniqueKey)"
          >
          </events-flow-url-settings>

          <events-flow-hha-caregiver-notes-settings
            *ngSwitchCase="EventsFlowActionNodeTypes.SendCaregiverNote"
            [actionItemFormGroup]="getActionItemSettingsForm(item?.value?.uniqueKey)"
            [caregiverNotes]="actionNotes?.caregiverNotes"
          >
          </events-flow-hha-caregiver-notes-settings>

          <events-flow-hha-patient-notes-settings
            *ngSwitchCase="EventsFlowActionNodeTypes.SendPatientNote"
            [actionItemFormGroup]="getActionItemSettingsForm(item?.value?.uniqueKey)"
            [patientNotes]="actionNotes?.patientNotes"
          >
          </events-flow-hha-patient-notes-settings>

          <events-fow-transcription-settings
            *ngSwitchCase="EventsFlowActionNodeTypes.TranscribeCallRecording"
            [actionItemFormGroup]="getActionItemSettingsForm(item?.value?.uniqueKey)"
          >
          </events-fow-transcription-settings>
        </div>

        <events-flow-event-filters *ngIf="isNodeEventType(item.type)" [node]="item"></events-flow-event-filters>
      </div>
    </div>
  </div>
</div>
